import { FormStepType } from "../types";
import getYesNoOptions from "../options/yes_no_options";
import { howLost, whereLost, dateLost } from "./fields/passport-details-fields";

export const lost_stolen_information: FormStepType = {
  id: 4,
  name: "passport-lost-stolen-information",
  title: "4. Lost/Stolen Information",
  disclaimer:
    "MINORS - If you are reporting a lost or stolen passport for a minor (persons under the age of 16), a parent or guardian must sign and mail in a paper DS-64 Statement Regarding Lost or Stolen Passport).",
  groups: [
    {
      name: "submitting-new-passport",
      fields: [
        {
          component: "Radio",
          name: "submittingNewPassport",
          label: "Do you want to order a new U.S. passport book and/or card?",
          type: "radio",
          validation: {
            required: "Please select an option.",
          },
          placeholder: "",
          options: getYesNoOptions({}),
          defaultValue: "No",
          cols: 12,
        },
      ],
    },
    {
      name: "change-name",
      fields: [
        {
          component: "Radio",
          name: "changeName",
          label: "Has your name changed since the passport was issued?",
          type: "radio",
          validation: {
            required: "Please select an option.",
          },
          placeholder: "",
          options: getYesNoOptions({}),
          defaultValue: "No",
          cols: 12,
        },
      ],
    },
    {
      name: "previous-name",
      condition: {
        field: "changeName",
        value: "yes",
      },
      fields: [
        {
          component: "TextInput",
          name: "previousName",
          label: "State your full name that appeared on the lost or stolen passport.",
          type: "text",
          placeholder: "Passport holder's name",
          cols: 4,
          maxLength: 21,
          validation: {
            required: "Please enter Full Name.",
            maxLength: 21,
            minLength: {
              value: 2,
              message: "The full name must have at least two characters.",
            },
          },
        },
      ],
    },
    {
      name: "passport-information",
      fields: [],
      subGroups: [
        {
          name: "passport-book-information",
          title: "U.S Passport Book",
          condition: {
            field: "documentType2",
            values: ["passportbook", "both"],
          },
          fields: [howLost({}), whereLost({}), dateLost({})],
          cols: 6,
        },
        {
          name: "passport-card-information",
          title: "U.S Passport Card",
          condition: {
            field: "documentType2",
            values: ["passportcard", "both"],
          },
          fields: [
            howLost({ type: "card" }),
            whereLost({ type: "card" }),
            dateLost({ type: "card" }),
          ],
          cols: 6,
        },
      ],
    },
    {
      name: "another-card-book-lost",
      fields: [
        {
          component: "Radio",
          name: "anotherCardBookLost",
          label: "Have you had another U.S. passport book/card lost or stolen?",
          type: "radio",
          validation: {
            required: "Please select an option.",
          },
          placeholder: "",
          options: getYesNoOptions({ checked: "no" }),
          cols: 12,
        },
      ],
    },
    {
      name: "another-lost-subgroup",
      condition: {
        field: "anotherCardBookLost",
        value: "yes",
      },
      fields: [
        {
          component: "TextInput",
          name: "anotherCardBookLostTimes",
          label: "How many times?",
          placeholder: "No. of times",
          type: "number",
          mask: "99",
          validation: {
            required: "Please enter the times.",
            min: { value: 1, message: "Please enter the times." },
            max: { value: 99, message: "Please enter the times." },
          },
          cols: 4,
        },
        {
          component: "Date",
          name: "anotherCardBookLostTimeFrame",
          label: "Approximate date?",
          type: "date",
          maxElegibleDate: "today",
          validation: { required: "Please select a date." },
          cols: 4,
          placeholder: "Please select a date.",
        },
        {
          component: "Radio",
          name: "anotherCardBookLostReported",
          label: "Did you file a police report?",
          type: "radio",
          class: "radio--inline",
          validation: {
            required: "Please select an option.",
          },
          placeholder: "",
          options: getYesNoOptions({}),
          defaultValue: "no",
          cols: 4,
        },
      ],
    },
  ],
};
